import type { JSX, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useSplitEnabled } from '@buffer-mono/features'
import { Skeleton } from '@buffer-mono/popcorn'

export const AffiliateProgramRoute = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const { isReady, isEnabled } = useSplitEnabled('geid-referral-program')

  if (!isReady) return <Skeleton width="100%" height="20px" />
  if (isEnabled) return <Navigate to="/settings/refer-a-friend" replace />
  return <>{children}</>
}
